export default "__VITE_ASSET__CKj1HC_w__"